import React from 'react'
import TableContainer from '../../common/TableContainer';

const MeetingRequestTable =  ({ columns, data = [], loading, limit, currentPage, nextId, prevId, handlePageChange, handlePageSize , hasMore, hidePagination }) => {



    return (
      <div>
        <TableContainer
        data={data}
        loading={loading}
        columns={columns}
        pageSize={limit}
        currentPage={currentPage}
        nextPageToken={nextId}
        prevPageToken={prevId}
        onPageSizeChange={handlePageSize}
        onPageChange={handlePageChange}
        hasMore={hasMore}
        hidePagination={hidePagination}
        />
      </div>
    );
  };

export default MeetingRequestTable